import { Box, VStack } from "@kazaar-platform/design-system";
import { useMemo } from "react";
import { useScrollDetectionV2 } from "../useScrollDetectionV2";
import { MAX_WIDTH } from "./usePageTemplate.constants";
import {
  type PageTemplateV2ContentProps,
  type PageTemplateV2HeaderProps,
  type PageTemplateV2Props,
} from "./usePageTemplate.types";

export const usePageTemplate = () => {
  const { isScrolled, ref } = useScrollDetectionV2();

  const PageTemplateV2 = useMemo(() => {
    const Base = ({ children, dataCy }: PageTemplateV2Props) => (
      <div
        className="flex h-full w-full flex-col overflow-hidden"
        data-cy={dataCy}
      >
        {children}
      </div>
    );

    const Header = ({ children }: PageTemplateV2HeaderProps) => (
      <VStack justify="center" shrink={0}>
        {children}
      </VStack>
    );

    const Content = ({
      children,
      p,
      px,
      py,
      mb,
    }: PageTemplateV2ContentProps) => (
      <Box
        grow={1}
        shrink={1}
        minH="0"
        maxW="100%"
        overflow="auto"
        ref={ref}
        id="page-content"
      >
        <Box maxW={MAX_WIDTH} p={p} px={px} py={py} mb={mb} m="auto" h="auto">
          {children}
        </Box>
      </Box>
    );

    Base.Header = Header;
    Base.Content = Content;

    return Base;
  }, [ref]);

  return {
    PageTemplateV2,
    isScrolled,
  };
};
